// extracted by mini-css-extract-plugin
module.exports = {"genericButtonDefaults":"styles_genericButtonDefaults__2oOXk"};